import { render, staticRenderFns } from "./CrearLaboratoriosDerivados.vue?vue&type=template&id=1904d337"
import script from "./CrearLaboratoriosDerivados.vue?vue&type=script&lang=js"
export * from "./CrearLaboratoriosDerivados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports